module.exports = __webpack_public_path__ + "img/send2.eee80358.png";